export const Updates_data = {
    "investors-presentation": {

        Meta_title: 'Investors Presentation H2 FY- 2025 | Marvel Blinds',
        OG_title: 'Investors Presentation H2 FY- 2025',
        Meta_Description: 'Intimation Investors Meet Post Earning Conference call H2 Financial Results for FY 2024-25 Intimation H2 FY2025 Webcast Video Recording Link Post Con Call H2 FY2025 Con call transcript H2 FY 2024-25',
        OG_Description: 'Intimation Investors Meet Post Earning Conference call H2 Financial Results for FY 2024-25 Intimation H2 FY2025 Webcast Video Recording Link Post Con Call H2 FY2025 Con call transcript H2 FY 2024-25',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/updates/investors-presentation`,


        pg_title: 'Investors Presentation H2 FY- 2025',
        data: [
            { title: "Intimation Investors Meet Post Earning Conference call H2 Financial Results for FY 2024-25", url: "/Content/Intimation H2 FY2025 Conference Call.pdf" },
            { title: "Intimation H2 FY2025 Webcast", url: "/Content/Intimation Video recording of H2 FY2025 Conference Call_signed.pdf" },
            { title: "Video Recording Link Post Con Call H2 FY2025", url: "https://www.youtube.com/watch?v=Q5iEVvusoQI" },
            { title: "Con call transcript H2 FY 2024-25", url: "/Content/Marvel_Decor_Ltd_H2_&_FY25_Post_Earnings_Conference_Call Final.pdf" }
        ]
    },
    "investors-presentation-nov-25": {

        Meta_title: 'Investors Presentation H2 FY- 2025 | Marvel Blinds',
        OG_title: 'Investors Presentation H2 FY- 2025',
        Meta_Description: 'Intimation Investors Meet Post Earning Conference call H2 Financial Results for FY 2024-25 Intimation H2 FY2025 Webcast Video Recording Link Post Con Call H2 FY2025 Con call transcript H2 FY 2024-25',
        OG_Description: 'Intimation Investors Meet Post Earning Conference call H2 Financial Results for FY 2024-25 Intimation H2 FY2025 Webcast Video Recording Link Post Con Call H2 FY2025 Con call transcript H2 FY 2024-25',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/updates/investors-presentation`,


        pg_title: 'Investors Presentation H2 FY- 2025',
        data: [
            { title: "Marvel Decor Ltd - H1 FY26 Concall Invite", url: "/Content/MarvelDecorLtd-H1FY26ConcallInvite.pdf" },
            { title: "Intimation H1 FY 2025-26 Webcast", url: "/Content/Link_15112025.pdf" },
            { title: "Video Recording Link Post Con call H1 FY 2025-26", url: "https://youtu.be/yOPWal6VdWY" },
            { title: "Transcript Con call H1 FY 2025-26", url: "/Content/Transcript_18112025.pdf`" },
            { title: "Presentation", url: "/Content/presentation_nov25.pdf" },
        ]
    },
    "investors-presentation-new": {

        Meta_title: 'Investors-presentation H1 FY 2024-25 | Marvel Blinds',
        OG_title: 'Investors-presentation H1 FY 2024-25',
        Meta_Description: 'Intimation Investors Meet Post Earning Conference call H1 Financial Results for FY 2024-25 Intimation H1 FY2024-25 Webcast Video Recording Link Post Con Call H1 FY2024-25 Presentation H1 FY 2024-25 Con call transcript',
        OG_Description: 'Intimation Investors Meet Post Earning Conference call H1 Financial Results for FY 2024-25 Intimation H1 FY2024-25 Webcast Video Recording Link Post Con Call H1 FY2024-25 Presentation H1 FY 2024-25 Con call transcript',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/updates/investors-presentation-new`,


        pg_title: 'Investors Presentation H2 FY- 2025',
        data: [
            { title: "Intimation Investors Meet Post Earning Conference call H1 Financial Results for FY 2024-25", url: "/Content/Intimation H1 FY-2025 Con call Invite.pdf" },
            { title: "Intimation H1 FY2024-25 Webcast", url: "/Content/MDL_18112024181234_Link_Meet_18112024.pdf" },
            { title: "Video Recording Link Post Con Call H1 FY2024-25", url: "https://www.youtube.com/watch?v=Nhv75Df1Zfw" },
            { title: "Presentation", url: "/Content/Marvel Decor - Investor Presentation.pdf" },
            { title: "H1 FY 2024-25 Con call transcript", url: "/Content/H1 FY25 Conference call transcript Website.pdf" }
        ]
    },
    "statement-of-deviations-or-variations": {

        Meta_title: 'Statement of Deviation(s) or Variation(s) | Marvel Blinds',
        OG_title: 'Statement of Deviation(s) or Variation(s)',
        Meta_Description: 'Intimation_Reg32_Marvel Regulation32_Marvel_30042019 Undertaking_Reg_32_1',
        OG_Description: 'Intimation_Reg32_Marvel Regulation32_Marvel_30042019 Undertaking_Reg_32_1',
        Meta_OG_URl: `${process.env.REACT_APP_WEBSITE_URL}/updates/statement-of-deviations-or-variations`,


        pg_title: 'Investors Presentation H2 FY- 2025',
        data: [
            { title: "Intimation_Reg32_Marvel", url: "/Content/Intimation_Reg32_Marvel.pdf" },
            { title: "Regulation32_Marvel_30042019", url: "/Content/Regulation32_Marvel_30042019.pdf" },
            { title: "Undertaking_Reg_32_1", url: "/Content/Undertaking_Reg_32_1.pdf" }
        ]
    }
}